import { render, staticRenderFns } from "./CardAdminRecolectores.vue?vue&type=template&id=aa3fa136&scoped=true"
import script from "./CardAdminRecolectores.vue?vue&type=script&lang=js"
export * from "./CardAdminRecolectores.vue?vue&type=script&lang=js"
import style0 from "./CardAdminRecolectores.vue?vue&type=style&index=0&id=aa3fa136&prod&scoped=true&lang=css"
import style1 from "./CardAdminRecolectores.vue?vue&type=style&index=1&id=aa3fa136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3fa136",
  null
  
)

export default component.exports